import React from 'react'
// components
import ActionsContainer from 'containers/Actions/Register'

const ActionsPage: React.FC = () => <ActionsContainer />

export default ActionsPage
